import React from 'react';
import { connect } from 'react-redux';
import { Field, change, blur } from 'redux-form';
import { SearchSelectBox } from 'jbc-front/components/SearchForm';
import { arrowRenderer } from 'jbc-front/components/Form';

import { getSelectOptions } from 'src/reducers/selectOptions';
import { fetchUniquePaymentDates, saveUniquePayrollRuleGroupIds, saveUniquePaymentDate } from 'src/reducers/searchForm';
import { ConfirmedOptionRenderer } from 'src/components';
import styles from 'src/components/PaymentDateSelectBoxes.scss';

const PaymentDateSelectBoxes = ({
  formName,
  dispatch,
  onlyConfirmed = false,
  updateLocation = true,
  uniquePaymentDates,
  uniquePayrollRuleGroups,
  uniquePayrollRuleGroupsCount
}) => {
  const handleGroupChange = newValue => {
    dispatch(blur(formName, 'uniquePayrollRuleGroups', newValue));
    dispatch(fetchUniquePaymentDates(formName, newValue, onlyConfirmed, updateLocation));
    dispatch(saveUniquePayrollRuleGroupIds(newValue));
  };

  const handlePaymentDateChange = (_event, newValue) => {
    dispatch(saveUniquePaymentDate(newValue));
  };

  const alterUniquePaymentDates = onlyConfirmed ? uniquePaymentDates.filter(payment => payment.confirmed) : uniquePaymentDates;
  return (
    <div className={styles.container}>
      {uniquePayrollRuleGroupsCount > 1 && (
        <div className={styles.payrollRuleGroupsWrapper}>
          <Field
            name="uniquePayrollRuleGroups"
            component={SearchSelectBox}
            options={uniquePayrollRuleGroups}
            onSelect={handleGroupChange}
            arrowRenderer={arrowRenderer}
          />
        </div>
      )}
      <div className={styles.payrollRuleDatesWrapper}>
        <Field
          optionRenderer={option => <ConfirmedOptionRenderer option={option} />}
          name="uniquePaymentDate"
          component={SearchSelectBox}
          options={alterUniquePaymentDates}
          arrowRenderer={arrowRenderer}
          onChange={handlePaymentDateChange}
        />
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  uniquePayrollRuleGroups: getSelectOptions(state, 'uniquePayrollRuleGroups'),
  uniquePaymentDates: getSelectOptions(state, 'uniquePaymentDates'),
  uniquePayrollRuleGroupsCount: getSelectOptions(state, 'uniquePayrollRuleGroups').length
});
export default connect(mapStateToProps)(PaymentDateSelectBoxes);
